var j = Object.defineProperty;
var I = (e, t, n) => t in e ? j(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var E = (e, t, n) => (I(e, typeof t != "symbol" ? t + "" : t, n), n);
import k from "mapbox-gl";
function g() {
}
function O(e) {
  return e();
}
function L() {
  return /* @__PURE__ */ Object.create(null);
}
function x(e) {
  e.forEach(O);
}
function V(e) {
  return typeof e == "function";
}
function K(e, t) {
  return e != e ? t == t : e !== t || e && typeof e == "object" || typeof e == "function";
}
function P(e) {
  return Object.keys(e).length === 0;
}
function Z(e, t, n) {
  e.insertBefore(t, n || null);
}
function A(e) {
  e.parentNode && e.parentNode.removeChild(e);
}
function p(e) {
  return document.createElement(e);
}
function G(e) {
  return Array.from(e.childNodes);
}
let y;
function b(e) {
  y = e;
}
function R() {
  if (!y)
    throw new Error("Function called outside component initialization");
  return y;
}
function U(e) {
  R().$$.on_mount.push(e);
}
const m = [], M = [];
let h = [];
const T = [], q = /* @__PURE__ */ Promise.resolve();
let N = !1;
function D() {
  N || (N = !0, q.then(F));
}
function B(e) {
  h.push(e);
}
const S = /* @__PURE__ */ new Set();
let d = 0;
function F() {
  if (d !== 0)
    return;
  const e = y;
  do {
    try {
      for (; d < m.length; ) {
        const t = m[d];
        d++, b(t), H(t.$$);
      }
    } catch (t) {
      throw m.length = 0, d = 0, t;
    }
    for (b(null), m.length = 0, d = 0; M.length; )
      M.pop()();
    for (let t = 0; t < h.length; t += 1) {
      const n = h[t];
      S.has(n) || (S.add(n), n());
    }
    h.length = 0;
  } while (m.length);
  for (; T.length; )
    T.pop()();
  N = !1, S.clear(), b(e);
}
function H(e) {
  if (e.fragment !== null) {
    e.update(), x(e.before_update);
    const t = e.dirty;
    e.dirty = [-1], e.fragment && e.fragment.p(e.ctx, t), e.after_update.forEach(B);
  }
}
function J(e) {
  const t = [], n = [];
  h.forEach((r) => e.indexOf(r) === -1 ? t.push(r) : n.push(r)), n.forEach((r) => r()), h = t;
}
const Q = /* @__PURE__ */ new Set();
function W(e, t) {
  e && e.i && (Q.delete(e), e.i(t));
}
function X(e, t, n) {
  const { fragment: r, after_update: a } = e.$$;
  r && r.m(t, n), B(() => {
    const c = e.$$.on_mount.map(O).filter(V);
    e.$$.on_destroy ? e.$$.on_destroy.push(...c) : x(c), e.$$.on_mount = [];
  }), a.forEach(B);
}
function Y(e, t) {
  const n = e.$$;
  n.fragment !== null && (J(n.after_update), x(n.on_destroy), n.fragment && n.fragment.d(t), n.on_destroy = n.fragment = null, n.ctx = []);
}
function $(e, t) {
  e.$$.dirty[0] === -1 && (m.push(e), D(), e.$$.dirty.fill(0)), e.$$.dirty[t / 31 | 0] |= 1 << t % 31;
}
function ee(e, t, n, r, a, c, u = null, _ = [-1]) {
  const s = y;
  b(e);
  const i = e.$$ = {
    fragment: null,
    ctx: [],
    // state
    props: c,
    update: g,
    not_equal: a,
    bound: L(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(t.context || (s ? s.$$.context : [])),
    // everything else
    callbacks: L(),
    dirty: _,
    skip_bound: !1,
    root: t.target || s.$$.root
  };
  u && u(i.root);
  let f = !1;
  if (i.ctx = n ? n(e, t.props || {}, (l, w, ...o) => {
    const C = o.length ? o[0] : w;
    return i.ctx && a(i.ctx[l], i.ctx[l] = C) && (!i.skip_bound && i.bound[l] && i.bound[l](C), f && $(e, l)), w;
  }) : [], i.update(), f = !0, x(i.before_update), i.fragment = r ? r(i.ctx) : !1, t.target) {
    if (t.hydrate) {
      const l = G(t.target);
      i.fragment && i.fragment.l(l), l.forEach(A);
    } else
      i.fragment && i.fragment.c();
    t.intro && W(e.$$.fragment), X(e, t.target, t.anchor), F();
  }
  b(s);
}
class te {
  constructor() {
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    E(this, "$$");
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    E(this, "$$set");
  }
  /** @returns {void} */
  $destroy() {
    Y(this, 1), this.$destroy = g;
  }
  /**
   * @template {Extract<keyof Events, string>} K
   * @param {K} type
   * @param {((e: Events[K]) => void) | null | undefined} callback
   * @returns {() => void}
   */
  $on(t, n) {
    if (!V(n))
      return g;
    const r = this.$$.callbacks[t] || (this.$$.callbacks[t] = []);
    return r.push(n), () => {
      const a = r.indexOf(n);
      a !== -1 && r.splice(a, 1);
    };
  }
  /**
   * @param {Partial<Props>} props
   * @returns {void}
   */
  $set(t) {
    this.$$set && !P(t) && (this.$$.skip_bound = !0, this.$$set(t), this.$$.skip_bound = !1);
  }
}
const ne = "4";
typeof window < "u" && (window.__svelte || (window.__svelte = { v: /* @__PURE__ */ new Set() })).v.add(ne);
const oe = {
  "AttributionControl.ToggleAttribution": "Attribution anzeigen/verstecken",
  "FullscreenControl.Enter": "Vollbildmodus aktivieren",
  "FullscreenControl.Exit": "Vollbildschirm beenden",
  "GeolocateControl.FindMyLocation": "Meinen Standort finden",
  "GeolocateControl.LocationNotAvailable": "Standort nicht verfügbar",
  "LogoControl.Title": "Mapbox homepage",
  "Map.Title": "Karte",
  "NavigationControl.ResetBearing": "Peilung auf Nord zurücksetzen",
  "NavigationControl.ZoomIn": "Vergrössern",
  "NavigationControl.ZoomOut": "Verkleinern",
  "ScrollZoomBlocker.CtrlMessage": "Benutzen Sie CTRL + Scroll, um die Karte zu zoomen",
  "ScrollZoomBlocker.CmdMessage": "Benutzen Sie ⌘ + Scroll, um die Karte zu zoomen",
  "TouchPanBlocker.Message": "Verwenden Sie zwei Finger, um die Karte zu verschieben"
};
function re(e) {
  let t;
  return {
    c() {
      t = p("div");
    },
    m(n, r) {
      Z(n, t, r), e[9](t);
    },
    p: g,
    i: g,
    o: g,
    d(n) {
      n && A(t), e[9](null);
    }
  };
}
function ie(e, t, n) {
  let { accesstoken: r } = t, { styleurl: a } = t, { latitude: c } = t, { longitude: u } = t, { zoom: _ } = t, { hidemarker: s = !1 } = t, { markercolor: i = "#999999" } = t, { markerimage: f = null } = t, l;
  U(() => {
    k.accessToken = r;
    let o = {
      cooperativeGestures: !0,
      container: l,
      style: a,
      center: [u, c],
      zoom: _
    };
    navigator.language.split("-")[0] === "de" && (o.locale = oe);
    const v = new k.Map(o);
    if (v.addControl(new k.NavigationControl()), !s)
      if (f != null) {
        const z = document.createElement("div");
        z.className = "bluc-map__marker", z.style.backgroundImage = `url(${f})`, new k.Marker(z).setLngLat([u, c]).addTo(v);
      } else
        new k.Marker({ color: i }).setLngLat([u, c]).addTo(v);
  });
  function w(o) {
    M[o ? "unshift" : "push"](() => {
      l = o, n(0, l);
    });
  }
  return e.$$set = (o) => {
    "accesstoken" in o && n(1, r = o.accesstoken), "styleurl" in o && n(2, a = o.styleurl), "latitude" in o && n(3, c = o.latitude), "longitude" in o && n(4, u = o.longitude), "zoom" in o && n(5, _ = o.zoom), "hidemarker" in o && n(6, s = o.hidemarker), "markercolor" in o && n(7, i = o.markercolor), "markerimage" in o && n(8, f = o.markerimage);
  }, [
    l,
    r,
    a,
    c,
    u,
    _,
    s,
    i,
    f,
    w
  ];
}
class ce extends te {
  constructor(t) {
    super(), ee(this, t, ie, re, K, {
      accesstoken: 1,
      styleurl: 2,
      latitude: 3,
      longitude: 4,
      zoom: 5,
      hidemarker: 6,
      markercolor: 7,
      markerimage: 8
    });
  }
}
export {
  ce as default
};
//# sourceMappingURL=bluc-map-V5jWel-1.js.map
